import React, { useContext } from 'react';
// import { Link, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RootContext from '../../context';
// import { PATH_ROOT } from '../../paths';
import googleplay from '../../../assets/svg/google-play.svg';
import appstore from '../../../assets/svg/appstore.svg';

export const Intro = () => {
  // const {id} = props.match.params;
  const { qrSrc } = useContext(RootContext);
  // console.log('[Intro].render', { normalEntrance });
  // const projectId = localStorage.getItem('projectId');
  // const backendURL = localStorage.getItem('backendURL');
  // const qrSrc = null;
  const { t } = useTranslation();

  // if (!normalEntrance) {
  //   return <Redirect to={
  //     projectId
  //       ? `${PATH_ROOT}project/${projectId}`
  //       : `${PATH_ROOT}`
  //   }/>;
  // }

  return (
    <>
      <h1 className="widget-title">Enface ID</h1>
      <p className="widget-subtitle">{t('about')}</p>
      <button className="widget-button" onClick={() => set('selfie')}>
        {t('selfieLogin')}
      </button>
      {/*<p className="widget-text">{t('accessCamera')}</p>*/}
      {/*<span className="widget-upper">{t('or')}</span>*/}
      {qrSrc && <img id="qrCode" src={qrSrc} alt="qr-code" className="widget-qr" />}
      <p className="widget-text">{t('scan')}</p>
      <div className="widget-footer">
        <div className="widget-footer-block">
          <a
            href="https://apps.apple.com/ru/app/enface/id1573435351"
            target="_blank"
            rel="noreferrer"
          >
            <img src={appstore} alt="appstore" className="widget-apple" />
          </a>
          <a
            href="https://docs.enface.ai/terms.html"
            target="_blank"
            rel="noreferrer"
          >
            {t('terms')}
          </a>
        </div>
        <div className="widget-footer-block">
          <a
            href="https://apps.apple.com/ru/app/enface/id1573435351"
            target="_blank"
            rel="noreferrer"
          >
            <img src={googleplay} className="widget-google" alt="google-play" />
          </a>
          <a
            href="https://docs.enface.ai/privacy.html"
            target="_blank"
            rel="noreferrer"
          >
            {t('privacy')}
          </a>
        </div>
      </div>
    </>
  );
};
/*
    <>
      <div>
        <ImgHolder>
          <Img src={girl}/>
        </ImgHolder>
        <SlideContainer>
          <SubText>
            Before we start
          </SubText>
          <Title>
            Allow access to the camera
          </Title>
          <SubText>
            Position your phone in front of your face and vertically to the ground
          </SubText>
        </SlideContainer>
      </div>
      <Link to={`${PATH_ROOT}${PATH_LIVENESS}`}>
        <IntroButton>
          Get Started
        </IntroButton>
      </Link>
    </>
 */
